import { useState, useEffect } from 'react';

// Cross-panel corner highlight, driven by hovering a corner card in the
// Corner Metrics panel. Detail: { cornerId, label, lat, lon, distFtMin,
// distFtMax } — dist fields absent when the corner has no distance span.
// Null detail clears the highlight.

const EVENT = 'trackapp:corner-highlight';

export function publishCornerHighlight(detail) {
  window.dispatchEvent(new CustomEvent(EVENT, { detail }));
}

export function useCornerHighlight() {
  const [highlight, setHighlight] = useState(null);
  useEffect(() => {
    const handler = (e) => setHighlight(e.detail || null);
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
  }, []);
  return highlight;
}
